const Twittertimeline = () => {
    return (
         
        <a className="twitter-timeline" data-tweet-limit="4" data-width="600" href="https://twitter.com/RiyaPau02772852?ref_src=twsrc%5Etfw">Tweets by RiyaPau02772852</a> 
        
     );
}
 
export default Twittertimeline;